import { component } from 'picoapp';

export default component(async (node) => {
  const countryButtons = node.querySelector('[data-countries]');
  const currentShop = window.theme.shops.find((shop) => shop.shopifyDomain === Shopify.shop);

  window.theme.shops.forEach((shop) => {
    const element = `
      <li>
        <a
          class="geoselector__list--item"
          data-current="${currentShop?.shopifyDomain === Shopify.shop ? 'true' : 'false'}"
          href="https://${shop.domain !== '' ? shop.domain : shop.shopifyDomain}"
        >
          <div class="block lg:hidden w-full p-3">
            <div class="aspect-ratio aspect-ratio--4/3">
              <img src="${shop.flagIcon}" alt="${shop.title}">
            </div>
          </div>
          <span class="hidden lg:block">
            ${shop.title}
          </span>
        </a>
      </li>
    `;
    countryButtons.insertAdjacentHTML('afterbegin', element);
  });
});
